import React, { useContext, useEffect, useState } from 'react'
import { ContextoAdminProtocolo } from './PrincipalAdminProtocolo'
import Modal from 'react-bootstrap/Modal';
import ReactPlayer from 'react-player/youtube'
import MsgUtils from '../Tools/MsgUtils';
import axios from 'axios';
import ModalMensajeInteractivo from '../utilsComponentes/ModalMensajeInteractivo';
import ProtocoloContenido from './ProtocoloContenido';
import encuestaImg from '../../assets/encuesta.png';
import UtilsBufer from '../Tools/UtilsBufer';
import EncuestaRespond from '../Formularios/EncuestaRespond';
import SinglePage from './SinglePage';
const server = process.env.REACT_APP_SERVER;
function ContenidoProtocolo() {
    const { info, setVentana, regional, setLoader, actualizar, setActualizar } = useContext(ContextoAdminProtocolo);
    const [menu, setMenu] = useState([]);
    const [modalDato, setModalDato] = useState(false);
    const [descripcion, setDescripcion] = useState('');
    const [tipoInfo, setTipoInfo] = useState('');
    const [titulo, setTitulo] = useState('');
    const [tipo, setTipo] = useState('');
    const [selectMenu, setSelectMenu] = useState({});
    const [selContenido, setSelContenido] = useState('');
    const [modificado, setModificado] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);
    const [modalAlerta, setModalAlerta] = useState(false);
    const [urlVideo, setUrlVideo] = useState('');
    const [hayExamen, setHayExamen] = useState(false);
    const [encuestas, setEncuestas] = useState([]);
    const [idEncuesta, setIdEncuesta] = useState(0);
    const [selectEncuesta, setSelectEncuesta] = useState({});
    const [tipoM, setTipoM] = useState('');
    function getImagen(dato) {
        //console.log(dato);
        if (dato.TIPO_INFO === 'IMG') {
            return "fa-solid fa-image";
        } else if (dato.TIPO_INFO === 'IMGNS') {
            return "fa-solid fa-images";
        } else if (dato.TIPO_INFO === 'PDF') {
            return "fa-solid fa-file-pdf"
        } else if (dato.TIPO_INFO === 'DOC') {
            return "fa-solid fa-file-word"
        } else if (dato.TIPO_INFO === 'VID') {
            return "fa-brands fa-youtube"
        } else if (dato.TIPO_INFO === "EXA") {
            return "fa-solid fa-pen-clip"
        } else {
            return "fa-solid fa-caret-down";
        }
    }
    function nuevoMenu(data, dataTitulo, info) {
        if (info !== null) {
            setSelectMenu(info);
        }
        setTitulo(dataTitulo);
        setTipo(data);
        setModalDato(true);
    }
    function editarMenu(dato, i) {
        setTipo(dato.TIPO);
        setTipoInfo(dato.TIPO_INFO);
        setDescripcion(dato.DESCRIPCION);
        setTitulo("Editar Menu");
        setSelectMenu({ ...dato, "INDEX": i });
        setModalDato(true);
    }
    const cargarContenido = async (e, tipoDoc) => {
        setModificado(true);
        setLoader(true);
        var archiv = e.target.files[0];
        if (archiv.size / 1000000 < 3.5) {
            var formData = new FormData()
            var info = JSON.parse(localStorage.getItem("info"))
            formData.append('FILE1', new Blob([archiv], { contentType: 'application/octet-stream', contentTransferEncoding: 'binary' }), archiv.name + "." + regional + "." + info.ID_EMPLEADO);
            //try {
            await axios.post(`${server}/protocolos/cargarImagen`, formData, {
                'Accept': 'application/json',
                'content-type': 'multipart/form-data'
            }).then(res => {
                var id = res.data.ok.V_ID;
                var nombre = archiv.name.split('.');
                var archivo = "PROTOCOLO_ADJ_" + id + '.' + nombre[nombre.length - 1];
                var menuAux = menu;
                var selec = menuAux[selectMenu.INDEX];
                if (selec.TIPO_INFO === 'MENU') {
                    var pos = menuAux[selectMenu.INDEX].SUBMENU.map(item => item.DESCRIPCION).indexOf(selectMenu.DESCRIPCION);
                    if (menuAux[selectMenu.INDEX].SUBMENU[pos].CONTENIDO === undefined) {
                        menuAux[selectMenu.INDEX].SUBMENU[pos].CONTENIDO = [];
                    }
                    menuAux[selectMenu.INDEX].SUBMENU[pos].CONTENIDO.push({ "ID_ADJUNTO": id, "URL": archivo, "TIPO": tipoDoc });
                    setMenu(menuAux);
                    setSelectMenu({ ...menuAux[selectMenu.INDEX].SUBMENU[pos], "INDEX": selectMenu.INDEX })
                } else {
                    if (menuAux[selectMenu.INDEX].CONTENIDO === undefined) {
                        menuAux[selectMenu.INDEX].CONTENIDO = [];
                    }
                    menuAux[selectMenu.INDEX].CONTENIDO.push({ "ID_ADJUNTO": id, "URL": archivo, "TIPO": tipoDoc });
                    setMenu(menuAux);
                    setSelectMenu({ ...menuAux[selectMenu.INDEX], "INDEX": selectMenu.INDEX });
                }
                setLoader(false);
            }).catch(error => {
                //console.log(error);
                MsgUtils.msgError(JSON.parse(error.request.response).error);
                setLoader(false);
            })
        } else {
            MsgUtils.msgError("Suba Imagen < 3.5 Megas");
            setLoader(false);
        }
    }
    const agregarMenu = () => {
        var hay = menu.filter((item) => item.DESCRIPCION === descripcion)
        if (hay.length === 0) {
            setModificado(true);
            var info = selectMenu.INDEX;
            if (info === undefined) {
                if (tipo === 'P') {
                    setMenu([...menu, {
                        ID_PROTOCOLO_PASO: 0,
                        ID_PASO_PADRE: null,
                        DESCRIPCION: descripcion,
                        TIPO: tipo,
                        TIPO_INFO: tipoInfo,
                        HAYSUBMENU: 0,
                        SUBMENU: []
                    }])
                } else if (tipo === 'S') {
                    var pos = menu.map(item => item.DESCRIPCION).indexOf(selectMenu.DESCRIPCION);
                    var hay = menu[pos].SUBMENU.filter((item) => item.DESCRIPCION === descripcion);
                    if (hay.length === 0) {
                        var aux = menu;
                        aux[pos].SUBMENU.push({
                            ID_PROTOCOLO_PASO: 0,
                            ID_PASO_PADRE: null,
                            DESCRIPCION: descripcion,
                            TIPO: tipo,
                            TIPO_INFO: tipoInfo,
                            HAYSUBMENU: 0,
                            SUBMENU: []
                        });
                        aux[pos].HAYSUBMENU += 1
                        setMenu(aux);
                    } else {
                        MsgUtils.msgError("Ya existe menu :" + descripcion);
                    }
                }
            } else {
                if (tipo === 'P') {
                    var men = menu;
                    men[selectMenu.INDEX].DESCRIPCION = descripcion;
                    men[selectMenu.INDEX].TIPO_INFO = tipoInfo;
                    setMenu(men);
                } else {
                    var men = menu;
                    var subm = men[selectMenu.INDEX].SUBMENU;
                    var pocition = men[selectMenu.INDEX].SUBMENU.map(item => item.DESCRIPCION).indexOf(selectMenu.DESCRIPCION);
                    subm[pocition].DESCRIPCION = descripcion;
                    subm[pocition].TIPO_INFO = tipoInfo;
                    men[selectMenu.INDEX].SUBMENU = subm;
                    setMenu(men);
                }
            }
            setSelectMenu({});
            setDescripcion('');
            setTipoInfo('');
            setModalDato(false);
        } else {
            MsgUtils.msgError("Ya existe menu :" + descripcion);
        }
    }
    function seleccionarMenuContenido(dato, i) {
        console.log(dato);
        setSelContenido(dato.DESCRIPCION);
        setSelectMenu({ ...dato, "INDEX": i });
        if (dato.TIPO_INFO == 'VID') {
            if (dato.CONTENIDO != undefined) {
                if (dato.CONTENIDO.length !== 0) {
                    setUrlVideo(dato.CONTENIDO[0].URL)
                }
            }
        } else if (dato.TIPO_INFO == 'EXA') {
            fetch(`${server}/formulario/getFormularios`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    regional
                })
            })
                .then(res => res.json())
                .then(data => {
                    if (data.ok) {
                        var filtrado = data.ok.filter((item) => item.ESTADO == 'A');
                        setSelectEncuesta(data.ok.filter((item) => item.ID_ENCUESTA == idEncuesta)[0]);
                        setEncuestas(filtrado);
                    } else {
                        MsgUtils.msgError(data.error)
                    }
                })
                .catch(err => MsgUtils.msgError(err));
        }
    }
    function elegirEncuesta(valor) {
        setIdEncuesta(valor);
        var aux = encuestas.filter(item => item.ID_ENCUESTA == valor)[0]
        setSelectEncuesta(aux);
        setHayExamen(true);
    }
    function eliminarMenuLocal() {
        var menuAux = menu;
        if (menuAux[selectMenu.INDEX].DESCRIPCION === selectMenu.DESCRIPCION) {
            setMenu(menuAux.filter((item) => item.DESCRIPCION !== selectMenu.DESCRIPCION));
            setSelectMenu({});
        } else {
            menuAux[selectMenu.INDEX].SUBMENU = menuAux[selectMenu.INDEX].SUBMENU.filter(item => item.DESCRIPCION !== selectMenu.DESCRIPCION);
            setMenu(menuAux);
            setSelectMenu({});
        }
    }
    function eliminarEncuesta(valor) {
        setLoader(true);
        fetch(`${server}/protocolos/cambiarEncuesta`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional, 'ID_PROTOCOLO': info.ID_PROTOCOLO, 'ID_ENCUESTA': valor
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    MsgUtils.msgCorrecto(data.ok)
                    setModalAlerta(false);
                    if (valor == null) {
                        setSelectEncuesta({});
                        setHayExamen(false);
                    }
                } else {
                    MsgUtils.msgError(data.error);
                }
                setLoader(false);
            })
            .catch(err => MsgUtils.msgError(err));
    }
    function functionEliminarAdj(tipo) {
        if (tipo) {
            if (tipoM == 'A') {
                if (selectMenu.POCITION !== undefined) {
                    eliminarFoto();
                } else if (selectMenu.ESMENU !== undefined) {
                    if (selectMenu.ID_PROTOCOLO_PASO !== 0) {
                        eliminarMenu();
                    } else {
                        eliminarMenuLocal();
                        setModalAlerta(false);
                    }
                }
            } else {
                eliminarEncuesta(null);
            }
        } else {
            setModalAlerta(false);
        }
    }
    function eliminarMenu() {
        fetch(`${server}/protocolos/eliminarMenu`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional, ...selectMenu
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    eliminarMenuLocal();
                    MsgUtils.msgCorrecto(data.ok);
                    setModalAlerta(false);
                } else {
                    MsgUtils.msgError(data.error);
                }
                setLoader(false);
            })
            .catch(err => MsgUtils.msgError(err));
    }
    function eliminarFoto() {
        var info = menu;
        var select = info[selectMenu.INDEX];
        if (select.TIPO_INFO !== "MENU") {
            var adj = info[selectMenu.INDEX].CONTENIDO[selectMenu.POCITION];
            fetch(`${server}/protocolos/eliminarAdjunto`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    regional, ...adj
                })
            })
                .then(res => res.json())
                .then(data => {
                    if (data.ok) {
                        delete info[selectMenu.INDEX].CONTENIDO;
                        setMenu(info);
                        setSelectMenu(info[selectMenu.INDEX]);
                        MsgUtils.msgCorrecto(data.ok);
                        setModalAlerta(false);
                    } else {
                        MsgUtils.msgError(data.error);
                    }
                    setLoader(false);
                })
                .catch(err => MsgUtils.msgError(err));
        } else {
            var pos = info[selectMenu.INDEX].SUBMENU.map(item => item.DESCRIPCION).indexOf(selectMenu.DESCRIPCION);
            var adj = info[selectMenu.INDEX].SUBMENU[pos].CONTENIDO[selectMenu.POCITION];
            fetch(`${server}/protocolos/eliminarAdjunto`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    regional, ...adj
                })
            })
                .then(res => res.json())
                .then(data => {
                    if (data.ok) {
                        info[selectMenu.INDEX].SUBMENU[pos].CONTENIDO = info[selectMenu.INDEX].SUBMENU[pos].CONTENIDO.filter(item => item.ID_ADJUNTO !== adj.ID_ADJUNTO)
                        setMenu(info);
                        setSelectMenu({ ...info[selectMenu.INDEX].SUBMENU[pos], "INDEX": selectMenu.INDEX });
                        MsgUtils.msgCorrecto(data.ok);
                        setModalAlerta(false);
                    } else {
                        MsgUtils.msgError(data.error);
                    }
                    setLoader(false);
                })
                .catch(err => MsgUtils.msgError(err));
        }
    }
    function funcionMsg(tipo) {
        //console.log(tipo);
        if (tipo) {
            setVentana(0);
        } else {
            setModalMsg(false);
        }
    }
    function guardarProtocolo() {
        setLoader(true);
        fetch(`${server}/protocolos/guargarContenido`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional, info, menu, idEmpleado: JSON.parse(localStorage.getItem('info')).ID_EMPLEADO
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    setVentana(0);
                    setActualizar(!actualizar);
                    MsgUtils.msgCorrecto(data.ok);
                } else {
                    MsgUtils.msgError(data.error);
                }
                setLoader(false);
            })
            .catch(err => { setLoader(false); MsgUtils.msgError(err) });
    }
    function salirEdicion() {
        setVentana(0);
        setActualizar(!actualizar);
    }
    function agregarVideo() {
        if (urlVideo !== '') {
            setModificado(true);
            var menuAux = menu;
            var selec = menuAux[selectMenu.INDEX];
            if (selec.TIPO_INFO === 'MENU') {
                var pos = menuAux[selectMenu.INDEX].SUBMENU.map(item => item.DESCRIPCION).indexOf(selectMenu.DESCRIPCION);
                if (menuAux[selectMenu.INDEX].SUBMENU[pos].CONTENIDO === undefined) {
                    menuAux[selectMenu.INDEX].SUBMENU[pos].CONTENIDO = [];
                }
                if (menuAux[selectMenu.INDEX].SUBMENU[pos].CONTENIDO.length === 0) {
                    menuAux[selectMenu.INDEX].SUBMENU[pos].CONTENIDO.push({ "ID_ADJUNTO": 0, "URL": urlVideo, "TIPO": 'VID' });
                } else {
                    menuAux[selectMenu.INDEX].SUBMENU[pos].CONTENIDO[0].URL = urlVideo;
                }
                setMenu(menuAux);
                setSelectMenu({ ...menuAux[selectMenu.INDEX].SUBMENU[pos], "INDEX": selectMenu.INDEX })
            } else {
                if (menuAux[selectMenu.INDEX].CONTENIDO === undefined) {
                    menuAux[selectMenu.INDEX].CONTENIDO = [];
                }
                if (menuAux[selectMenu.INDEX].CONTENIDO.length === 0) {
                    menuAux[selectMenu.INDEX].CONTENIDO.push({ "ID_ADJUNTO": 0, "URL": urlVideo, "TIPO": 'VID' });
                } else {
                    menuAux[selectMenu.INDEX].CONTENIDO[0].URL = urlVideo;
                }
                setMenu(menuAux);
                setSelectMenu({ ...menuAux[selectMenu.INDEX], "INDEX": selectMenu.INDEX });
            }
        } else {
            MsgUtils.msgError("Ingrese url del video ...")
        }
    }
    useEffect(() => {
        if (info.MENU.length !== 0 && menu.length === 0) {
            setMenu(info.MENU);
        }
        if (info.ID_ENCUESTA !== undefined && info.ID_ENCUESTA !== null) {
            setHayExamen(true);
            setIdEncuesta(info.ID_ENCUESTA);
        } else {
            setHayExamen(false);
        }
    }, [menu])
    return (
        <div>
            <div className='container-fluid bg-gradient bg-dark text-light py-1'>
                <div className='row row-cols-1 row-cols-sm-2 '>
                    <div className='col-8 col-sm-8 my-auto'>
                        {info.DESCRIPCION}
                    </div>
                    {modificado && <div className='col-8 col-sm-2 text-end my-auto'>
                        <a className='btn btn-success btn-sm' onClick={() => guardarProtocolo()}>
                            <i className="fa-solid fa-floppy-disk fa-xl"></i> Guardar
                        </a>
                    </div>}
                    <div className={`col-4 ${modificado ? 'col-sm-2' : 'col-sm-4'} text-end my-auto`}>
                        <a className='btn btn-transparent fs-4 m-0 p-0 text-danger px-2' onClick={() => { modificado ? setModalMsg(true) : salirEdicion() }}>
                            <i className="fa-solid fa-circle-xmark fa-xl"></i>
                        </a>
                    </div>
                </div>
            </div>
            <div className='container-fluid'>
                <div className='row row-cols-1 row-cols-sm-2 g-0'>
                    <div className='col col-sm-3 p-0 m-0'>
                        <ul className="list-group py-sm-4">
                            {info.ESTADO !== 'A' && <div className='container-fluid text-center fw-bold' style={{ fontSize: "20px" }}>
                                <button className='btn btn-success btn-sm w-100'
                                    onClick={() => { setSelectMenu({}); nuevoMenu('P', "Agregar Nuevo Menu", null); }}>
                                    <i className="fa-solid fa-circle-plus fa-xl"></i> Agregar Menu
                                </button>
                            </div>}
                            {menu.length !== 0 && menu.map((item, index) => {
                                if (item.HAYSUBMENU === 0) {
                                    return (
                                        <li className="list-group-item bg-dark bg-gradient m-0 p-1" key={index}>
                                            <div className={`btn-group btn-group-sm w-100 ${selContenido === item.DESCRIPCION ? 'border border-2 border-success' : ''}`}>
                                                <button className='btn btn-sm btn-dark text-light fw-bold text-start'
                                                    onClick={() => seleccionarMenuContenido(item, index)} style={{ width: '140px' }}>
                                                    <i className={getImagen(item)}></i> {item.DESCRIPCION}
                                                </button>
                                                {info.ESTADO !== 'A' && <button className='btn btn-sm text-danger' onClick={() => { setTipoM('A'); setSelectMenu({ ...item, "INDEX": index, "ESMENU": true }); setModalAlerta(true); }}>
                                                    <i className="fa-solid fa-trash fa-xl"></i>
                                                </button>}
                                                {info.ESTADO !== 'A' && <button className='btn btn-sm text-warning' onClick={() => editarMenu(item, index)}>
                                                    <i className="fa-solid fa-pen-to-square fa-xl"></i>
                                                </button>}
                                                {item.TIPO_INFO === 'MENU' && info.ESTADO !== 'A' &&
                                                    <button className='btn btn-sm text-success'
                                                        onClick={() => nuevoMenu('S', 'Agregar Submenu', item)}>
                                                        <i className="fa-solid fa-circle-plus fa-xl"></i>
                                                    </button>}
                                            </div>
                                        </li>
                                    )
                                } else {
                                    return (
                                        <li className="list-group-item bg-dark bg-gradient m-0 p-1 " key={index}>
                                            <div className='container-fluid m-0 p-0'>
                                                <div className='row row-cols-2'>
                                                    <div className='col-6'>
                                                        <a className="btn btn-sm w-100 text-light fw-bold text-start"
                                                            data-bs-toggle="collapse" href={`#${item.DESCRIPCION}`}
                                                            role="button" aria-expanded="false" aria-controls="collapseExample">
                                                            <i className={getImagen(item)}></i> {item.DESCRIPCION}
                                                        </a>
                                                    </div>
                                                    {info.ESTADO !== 'A' && <div className='col-6'>
                                                        <div className='btn-group btn-group-sm w-100'>
                                                            <button className='btn btn-sm text-danger'
                                                                onClick={() => { setTipoM('A'); setSelectMenu({ ...item, "INDEX": index, "ESMENU": true }); setModalAlerta(true); }}>
                                                                <i className="fa-solid fa-trash fa-xl"></i>
                                                            </button>
                                                            <button className='btn btn-sm text-warning' onClick={() => editarMenu(item, index)}>
                                                                <i className="fa-solid fa-pen-to-square fa-xl"></i>
                                                            </button>
                                                            {item.TIPO_INFO === 'MENU' &&
                                                                <button className='btn btn-sm text-success'
                                                                    onClick={() => nuevoMenu('S', 'Agregar Submenu', item)}>
                                                                    <i className="fa-solid fa-circle-plus fa-xl"></i>
                                                                </button>}
                                                        </div>
                                                    </div>}
                                                </div>
                                            </div>
                                            <div className="collapse" id={`${item.DESCRIPCION}`}>
                                                <ul className="list-group ">
                                                    {item.SUBMENU.map((subm, ind) => {
                                                        return (
                                                            <li className={`list-group-item bg-dark bg-gradient p-0 ${selContenido === subm.DESCRIPCION ? 'border border-2 border-success' : ''}`}
                                                                key={ind} style={{ marginLeft: '10px' }}>
                                                                <div className='btn-group btn-group-sm w-100'>
                                                                    <button className='btn btn-sm text-light fw-bold text-start' style={{ width: '120px' }}
                                                                        onClick={() => seleccionarMenuContenido(subm, index)}
                                                                    ><i className={getImagen(subm)}></i> {subm.DESCRIPCION}</button>
                                                                    {info.ESTADO !== 'A' && <button className='btn btn-sm text-danger'
                                                                        onClick={() => { setTipoM('A'); setSelectMenu({ ...subm, "INDEX": index, "ESMENU": true }); setModalAlerta(true) }}>
                                                                        <i className="fa-solid fa-trash-can fa-xl"></i>
                                                                    </button>}
                                                                    {info.ESTADO !== 'A' && <button className='btn btn-sm text-warning' onClick={() => editarMenu(subm, index)}>
                                                                        <i className="fa-solid fa-pen-to-square fa-xl"></i>
                                                                    </button>}
                                                                </div>
                                                            </li>
                                                        )
                                                    })}
                                                </ul>
                                            </div>
                                        </li>)
                                }
                            })}
                        </ul>
                    </div>
                    <div className='col col-sm-9'>
                        {selContenido !== '' && info.ESTADO !== 'A' &&
                            <div className='container-fluid'>
                                <div className='text-center text-dark'>
                                    {`CONTENIDO PARA -> ${selectMenu.DESCRIPCION}`}
                                </div>
                                {selectMenu.TIPO_INFO === 'IMG' &&
                                    <div className='container-fluid border'>
                                        <div className='card bg-dark bg-gradient '>
                                            <div className='card-header m-0 p-0'>
                                                <div className='row row-cols-2 g-0'>
                                                    <div className='col col-10 text-light text-center'>Agregar Imagen</div>
                                                    <div className='col col-2 text-success text-end'>
                                                        <label className='btn btn-sm text-success'>
                                                            <i className="fa-solid fa-file-circle-plus fa-2xl"></i>
                                                            <input type="file" accept='image/*' disabled={(selectMenu.CONTENIDO !== undefined && selectMenu.CONTENIDO.length > 0) ? true : false}
                                                                onChange={(e) => cargarContenido(e, 'IMG')} />
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='card-body m-0 p-0'>
                                                {selectMenu.CONTENIDO !== undefined && selectMenu.CONTENIDO.length > 0 &&
                                                    <div className='position-relative m-2'>
                                                        <img src={`${server}/imagenes/${selectMenu.CONTENIDO[0].URL}`} className="d-block w-100 h-20" />
                                                        <a className="btn position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                                                            onClick={() => { setTipoM('A'); setSelectMenu({ ...selectMenu, "POCITION": 0 }); setModalAlerta(true) }}>
                                                            X
                                                        </a>
                                                    </div>}
                                                <div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>}
                                {selectMenu.TIPO_INFO === 'IMGNS' &&
                                    <div className='container-fluid border'>
                                        <div className='card bg-dark bg-gradient'>
                                            <div className='card-header m-0 p-0'>
                                                <div className='row row-cols-2 g-0'>
                                                    <div className='col col-10 text-light text-center'>Agregar Imagen</div>
                                                    <div className='col col-2 text-success text-end'>
                                                        <label className='btn btn-sm text-success'>
                                                            <i className="fa-solid fa-file-circle-plus fa-2xl"></i>
                                                            <input type="file" accept='image/*'
                                                                onChange={(e) => cargarContenido(e, 'IMG')} />
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='card-body m-0 p-0'>
                                                {selectMenu.CONTENIDO !== undefined &&
                                                    <div className='container-fluid'>
                                                        <div className='row g-1'>
                                                            {selectMenu.CONTENIDO.map((item, index) => {
                                                                return (
                                                                    <div className='col col-sm-6 col-md-4' key={index}>
                                                                        <div className='position-relative'>
                                                                            <img src={`${server}/imagenes/${item.URL}`} className="d-block w-100 h-20" />
                                                                            <a className="btn position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                                                                                onClick={() => { setTipoM('A'); setSelectMenu({ ...selectMenu, "POCITION": index }); setModalAlerta(true) }}>
                                                                                X
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                    </div>}
                                            </div>
                                        </div>
                                    </div>
                                }
                                {selectMenu.TIPO_INFO === 'VID' &&
                                    <div className='container-fluid border ' >
                                        <div className='card bg-dark bg-gradient '>
                                            <div className='card-header m-0 p-0'>
                                                <div className="input-group input-group-sm">
                                                    <span className="input-group-text bg-dark border-dark text-light" id="basic-addon1">URL</span>
                                                    <input type="text" className="form-control form-control-sm"
                                                        placeholder="url de video de youtube" id="textUrl"
                                                        onChange={(e) => setUrlVideo(e.target.value)}
                                                        value={urlVideo} />
                                                    <button className='btn btn-sm btn-success'
                                                        onClick={() => agregarVideo()}><i className="fa-solid fa-plus"></i> Agregar</button>
                                                </div>
                                            </div>
                                            {selectMenu.CONTENIDO !== undefined && selectMenu.CONTENIDO.length > 0 &&
                                                <div className='card-body m-0 p-0'>
                                                    <div className='container-fluid p-2'>
                                                        <ReactPlayer url={selectMenu.CONTENIDO[0].URL} width='100%' />
                                                    </div>
                                                </div>}
                                        </div>
                                    </div>
                                }
                                {selectMenu.TIPO_INFO === 'EXA' &&
                                    <div className='container-fluid border'>
                                        <div className='card bg-dark bg-gradient '>
                                            <div className='card-header m-0 p-0'>
                                                <div className="input-group input-group-sm my-auto" >
                                                    <span className="input-group-text bg-dark bg-gradient text-light border-dark" >Nombre Encuesta</span>
                                                    <select className=" form-select text-center "
                                                        disabled={hayExamen}
                                                        value={idEncuesta} onChange={(e) => elegirEncuesta(e.target.value)}
                                                    >
                                                        <option value={0}>NINGUNO</option>
                                                        {encuestas.map((item, index) => {
                                                            return (<option value={item.ID_ENCUESTA} key={index}>{item.TITULO}</option>)
                                                        })}

                                                    </select>
                                                </div>
                                            </div>
                                            <div className='card-body'>
                                                {hayExamen == true && <div className='row row-cols-2 g-1'>
                                                    <div className='col-2 my-auto text-center'>
                                                        <div className='position-relative'>
                                                            <img src={encuestaImg} className='img-fluid' />
                                                            <a className="btn position-absolute top-0 start-0 translate-middle badge rounded-pill bg-danger"
                                                                onClick={() => { setTipoM('E'); setModalAlerta(true) }}>
                                                                X
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <div className='col-10'>
                                                        <div className='text-center text-light fw-bold' style={{ fontSize: '22px' }}>
                                                            {selectEncuesta.TITULO}
                                                        </div>
                                                        <div className="form-floating">
                                                            <textarea className="form-control" disabled={true} style={{ height: '200px' }}
                                                                value={UtilsBufer.getText(selectEncuesta.DESCRIPCION)}
                                                            ></textarea>
                                                            <label for="floatingTextarea2">Descripción</label>
                                                        </div>
                                                    </div>
                                                </div>}
                                            </div>
                                            {hayExamen && <div className='card-footer text-end'>
                                                <button className='btn btn-success btn-sm' onClick={() => eliminarEncuesta(idEncuesta)}>
                                                    <i className="fa-solid fa-floppy-disk fa-xl"></i> Guardar
                                                </button>
                                            </div>}
                                        </div>
                                    </div>
                                }
                                {selectMenu.TIPO_INFO === 'PDF' &&
                                    <div className='container-fluid border'>
                                        <div className='card bg-dark bg-gradient '>
                                            <div className='card-header m-0 p-0'>
                                                <div className='row row-cols-2 g-0'>
                                                    <div className='col col-10 text-light text-center'>Agregar Documento</div>
                                                    <div className='col col-2 text-success text-end'>
                                                        <label className='btn btn-sm text-success'>
                                                            <i className="fa-solid fa-file-circle-plus fa-2xl"></i>
                                                            <input type="file" accept='application/pdf' disabled={(selectMenu.CONTENIDO !== undefined && selectMenu.CONTENIDO.length > 0) ? true : false}
                                                                onChange={(e) => cargarContenido(e, 'PDF')} />
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='card-body m-0 p-0'>
                                                {selectMenu.CONTENIDO !== undefined && selectMenu.CONTENIDO.length > 0 &&
                                                    <div className='position-relative m-2'>
                                                        <iframe src={`${server}/imagenes/${selectMenu.CONTENIDO[0].URL}`} style={{width:'100%',height:'75vh'}} />
                                                        <a className="btn position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                                                            onClick={() => { setTipoM('A'); setSelectMenu({ ...selectMenu, "POCITION": 0 }); setModalAlerta(true) }}>
                                                            X
                                                        </a>
                                                    </div>}
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>}
                        {selContenido !== '' && info.ESTADO === 'A' && selectMenu.TIPO_INFO !== 'EXA' && <div className='py-2 px-2'><ProtocoloContenido info={selectMenu} regional={regional} encuesta={selectEncuesta} /></div>}
                        {selContenido !== '' && info.ESTADO === 'A' && selectMenu.TIPO_INFO == 'EXA' && selectEncuesta.ID_ENCUESTA !== undefined && <EncuestaRespond selectFormu={selectEncuesta} soloVer={true} />}
                    </div>
                </div>
            </div>
            <Modal show={modalDato} onHide={() => setModalDato(false)}
                size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                contentClassName='bg-dark bg-gradient'>
                <Modal.Header closeButton closeVariant='white' bsPrefix='modal-header m-0 p-0 px-2'>
                    <Modal.Title>
                        <div className='text-light'>{titulo}</div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='container-fluid'>
                        <div className="mb-3">
                            <label className="form-label text-light">Descripción</label>
                            <input type="text" className="form-control form-control-sm" value={descripcion} onChange={(e) => setDescripcion(e.target.value.toUpperCase())} />
                        </div>
                        <div className='mb-3'>
                            <label className='form-label text-light'>Tipo</label>
                            <select className="form-select form-select-sm btn-secondary text-center" value={tipoInfo} onChange={(e) => setTipoInfo(e.target.value)}>
                                <option value=''>NINGUNO</option>
                                <option value='IMG'>IMAGEN</option>
                                <option value='IMGNS'>IMAGENES</option>
                                <option value='PDF'>PDF DOC</option>
                                <option value='VID'>VIDEO</option>
                                <option value='EXA'>EVALUACION</option>
                                {tipo !== 'S' && <option value='MENU'>MENU</option>}
                            </select>
                        </div>
                        <button className='btn btn-sm btn-success w-100' onClick={() => agregarMenu()}>
                            Guardar
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
            <ModalMensajeInteractivo msg={'Seguro quiere salir, sin guardar los cambios ?'} collback={funcionMsg} show={modalMsg} />
            <ModalMensajeInteractivo msg={"ESTA SEGURO DE ELIMINAR ?"} collback={functionEliminarAdj} show={modalAlerta} />
        </div>
    )
}

export default ContenidoProtocolo
